import React from 'react';
import {Route, Routes} from 'react-router-dom';
import NavLink from './../../../common/nav_link'

class RoutingWrapper extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            routes: [
                {type: 'route', url: 'rewrite', name: 'Outgoing Rewrite Groups'},
                {type: 'route', url: 'callerid', name: 'Caller ID Groups'},
                {type: 'route', url: 'sipheaders', name: 'SIP Headers Groups'}
            ]
        }
    }
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <h2>Carrier Settings</h2>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-tabs">
                            {this.state.routes.map(function(row, index) {
                                return (
                                    <NavLink
                                        key={ index }
                                        to={`/carriers/settings/${ row.url }`}
                                        default={`/carriers/settings/rewrite`}
                                    >
                                        { row.name }
                                    </NavLink>
                                )
                            }, this)}
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}

export default class extends React.Component {
    render() {
        return (
            <div>
                <RoutingWrapper urlattrs={this.props.urlattrs} />
                <Routes>
                    {this.props.routes.map((route, i) => (
                        <Route 
                            key={i} 
                            path={route.path} 
                            element={<route.component routes={route.routes} childProps={this.props.childProps}/>} 
                        />
                    ))}
                </Routes>
            </div>
        )
    }
}